import { TextField, InputAdornment } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledSearchInput } from './index.style';

const SearchInput = ({
  value,
  name,
  placeholder,
  className,
  size = 'small',
  iconStart,
  iconEnd,
  onChange,
  styleInput,
  ...props
}) => {
  const { t } = useTranslation();

  const inputProps = useMemo(() => {
    const inputAdornmentProps = {};
    if (iconStart) {
      inputAdornmentProps.startAdornment = (
        <InputAdornment position="start">{iconStart}</InputAdornment>
      );
    }
    if (iconEnd) {
      inputAdornmentProps.endAdornment = (
        <InputAdornment position="end">{iconEnd}</InputAdornment>
      );
    }
    return inputAdornmentProps;
  }, [iconStart, iconEnd]);

  return (
    <StyledSearchInput className={className} styleInput={styleInput}>
      <TextField
        value={value}
        name={name}
        size={size}
        className="search-input"
        placeholder={t(placeholder)}
        onChange={onChange}
        InputProps={inputProps}
        {...props}
      />
    </StyledSearchInput>
  );
};

export default SearchInput;
